// Lazy entry for the hotspot image module.
// Only this stub lives in the main bundle. The component (JS + CSS) is a
// separate chunk that is fetched only on pages that contain a
// .bce_hotspot-image element, so all other pages load nothing extra.

let componentPromise = null;

function loadComponent() {
    if (!componentPromise) {
        componentPromise = import(
            /* webpackChunkName: "hotspot-image" */ './hotspot-image.js'
        ).then((module) => module.default);
    }
    return componentPromise;
}

export default {
    create(element) {
        loadComponent()
            .then((component) => component.create(element))
            .catch((error) => console.error('BCE Hotspot Image: failed to load component', error));
    }
};
